import { useState, useRef, useEffect } from 'react';
import { ReactComponent as SideFlower } from "../vectors/SideFlower.svg"
import { ReactComponent as BottomFlower } from "../vectors/BottomFlower.svg"
import { useInView } from 'framer-motion';
import FlowerBox from "../components/FlowerBox"
import Section from "../components/Section"
import Container from "../components/Container"
import Content from "../components/Content"
import FlowerDivider from '../components/FlowerDivider';
import toileImage from "../vectors/toile.png"
import HoverFade from '../motions/HoverFade';
import SlideIn from '../motions/SlideIn';
import SlideUp from '../motions/SlideUp';
import FadeIn from '../motions/FadeIn';
import Footer from '../components/Footer';
import PhotoRise from '../motions/PhotoRise';
import PageFade from '../motions/PageFade';
import { AnimatePresence } from 'framer-motion'

function Home() {
  console.log("Home rendered");

  useEffect(() => {
    console.log("Home mounted");

    return () => {
      console.log("Home unmounted");
    };
  }, []);

  const className = "mx-auto min-h-[630px] sm:min-h-[740px] md:min-h-[765px] lg:min-h-[845px] xl:min-h-[859px] 2xl:max-h-[900px]"
  return (
    <AnimatePresence mode="wait">
      <PageFade>
        <div className="w-full">
          <div className="relative w-full">
            <Hero
              className={className}
            />
            <MainImage
              className={className}
              src="/assets/images/home/main-photo.jpg"
              alt="Main wedding photo"
            />
          </div>
          <WeddingDetails />
          <MoreInfo />
          <OurStory />
          <Footer />
        </div>
      </PageFade>
    </AnimatePresence >
  );
}

export default Home;

const MainImage = ({ className, src, alt }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      {!loaded && ( /**Temporary Placeholder div until img loads */
        <div className="-z-10 bg-white w-full h-full" />
      )}
      <PhotoRise className={className}>
        <img
          src={src}
          alt={alt}
          style={{ height: 'calc(100% + 50px)' }}
          className={`2xl:object-[50%_35%] image aspect-[3/2] -z-10 top-0 left-0 absolute w-full object-cover ${className} ${loaded ? '' : 'hidden'}`}
          onLoad={() => setLoaded(true)}
        />
      </PhotoRise>
    </>
  )
}

const Hero = ({ className }) => {
  return (
    <div className={`hero relative w-full z-10 ${className}`}>
      <SlideIn delay={0.1}>
        <div className="names absolute font-antura text-bronze z-20 overflow-visible">
          Thuyan&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Jerry
        </div>
      </SlideIn>
      <SlideUp delay={0.4}>
        <div className="and absolute font-antura text-bronze z-20 ">
          &
        </div>
      </SlideUp>
      <div className="when-and-where absolute font-sourceserif text-bronze z-20 w-full hidden lg:flex justify-center">
        <div className="flex space-between justify-center text-center w-full">
          <div className="w-5/12">
            <FadeIn delay={0.75}>
              APRIL 25<sup>th</sup> 2026
            </FadeIn>
          </div>
          <div className="w-5/12">
            <FadeIn delay={0.95}>
              WASHINGTON D.C.
            </FadeIn>
          </div>
        </div>
      </div>
    </div>
  );
};

const WeddingDetails = () => {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true })
  return (
    <Section ref={ref} className="wedding-details">
      <FlowerBox>
        <SideFlower className="w-40 h-auto sm:w-48 md:w-auto md:h-full fill-current text-gold absolute left-0 top-0 z-0 opacity-20" />
        <SideFlower className="w-40 h-auto sm:w-48 md:w-auto md:h-full fill-current text-gold absolute right-0 top-0 z-0 opacity-20 -scale-x-100" />
        <Container>
          <FadeIn manualStart={true} start={isInView} delay={0.3}>
            <h2 className="heading text-gold">Wedding Details</h2>
          </FadeIn>
          <FadeIn manualStart={true} start={isInView} delay={0.6}>
            <div className="m-4">
              <p>Saturday, April 25, 2026 at 4:00 PM</p>
              <p>Meridian House</p>
              <p>1630 Crescent Place NW</p>
              <p>Washington, D.C.</p>
            </div>
          </FadeIn>
          <FadeIn manualStart={true} start={isInView} delay={0.9}>
            <FlowerDivider fillColor={"text-gold"} />
          </FadeIn>
        </Container>
      </FlowerBox>
    </Section>
  )
}

const MoreInfo = () => {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true })
  return (
    <Section ref={ref} className="wedding-information" bgColor='bg-blush'>
      <FlowerBox>
        <BottomFlower className="w-20 md:w-24 lg:w-36 xl:w-48 h-auto fill-current text-bronze absolute left-0 bottom-0 z-0 opacity-20" />
        <BottomFlower className="w-20 md:w-24 lg:w-36 xl:w-48 h-auto fill-current text-bronze absolute right-0 bottom-0 z-0 opacity-20 -scale-x-100" />
        <Container>
          <Content>
            <div className="flex flex-col items-center">
              <div className="flex flex-col lg:flex-row gap-4 mb-8 max-w-96 lg:max-w-full">
                <FadeIn manualStart={true} start={isInView} delay={0.3} className="p-4 text-center flex-1">
                  <div>
                    <div className="subheading text-bronze text-2xl lg:text-xl xl:text-2xl">WELCOME PARTY</div>
                    <div className="text-card">
                      Kick off the weekend with us at our
                      Friday evening Welcome Party! We'll
                      be serving dinner and drinks in a
                      celebratory atmosphere. Dressy but
                      comfortable attire is encouraged.
                      We’re excited to spend time with you
                      before the big day!
                    </div>
                  </div>
                </FadeIn>
                <FadeIn manualStart={true} start={isInView} delay={0.6} className="p-4 text-center flex-1">
                  <div>
                    <div className="subheading text-bronze text-2xl lg:text-xl xl:text-2xl">VENUE</div>
                    <div className="text-card">
                      Our wedding ceremony and
                      reception will be held at Meridian
                      House, a historic French-style
                      manor in the heart of Washington,
                      D.C. Parking is available on-site, but
                      we recommend using rideshare
                      services or carpooling.
                    </div>
                  </div>
                </FadeIn>
                <FadeIn manualStart={true} start={isInView} delay={0.9} className="p-4 text-center flex-1">
                  <div>
                    <div className="subheading text-bronze text-2xl lg:text-xl xl:text-2xl">ATTIRE</div>
                    <div className="text-card">
                      We kindly request black-tie or
                      formal attire at the wedding.
                      Tuxedos and floor-length gowns are
                      encouraged, but a dark suit and
                      elegant dress is just as welcome. No
                      need to buy anything new. We can’t
                      wait to see you looking your finest!
                    </div>
                  </div>
                </FadeIn>
              </div>
              <FadeIn manualStart={true} start={isInView} delay={1.2} className="w-full mb-12 z-10">
                <div className="aspect-[3/1] w-full">
                  <img
                    src="/assets/images/home/meridian.png"
                    alt="Meridian"
                    className="w-full h-full object-cover"
                  />
                </div>
              </FadeIn>
            </div>
            <FadeIn manualStart={true} start={isInView} delay={1.5}>
              <FlowerDivider fillColor={"text-bronze"} />
            </FadeIn>
          </Content>
        </Container>
      </FlowerBox>
    </Section>
  )
}

const OurStory = () => {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true })
  return (
    <Section ref={ref} className="our-story" bgColor='bg-rose' bgImage={toileImage}>
      <Container>
        <FadeIn manualStart={true} start={isInView} delay={0.3}>
          <h2 className="heading text-blush">
            Our Story
          </h2>
        </FadeIn>
        <div className="w-full pt-12">
          <div className="w-full flex flex-col sm:flex-row space-y-8 sm:space-x-10 md:space-x-14 sm:space-y-0 justify-center">
            <FadeIn manualStart={true} start={isInView} delay={0.6} className="flex-1 hover:cursor-pointer">
              <HoverFade
                className="aspect-[2/3] relative"
                front={
                  <img
                    src="/assets/images/home/photo1.jpg"
                    alt="Image 1"
                    className="w-full h-full object-cover"
                  />
                }
                overlay={
                  <div className="photo-card">
                    <p className="photo-card-description">
                      Jerry and Thuyan first crossed paths in Washington D.C. back in 2018.
                      Though the timing wasn’t right, they were both in relationships and
                      only exchanged a few conversations before going their separate ways...
                    </p>
                  </div>
                }
              />
            </FadeIn>
            <FadeIn manualStart={true} start={isInView} delay={0.9} className="flex-1 hover:cursor-pointer">
              <HoverFade
                className="aspect-[2/3] relative"
                front={
                  <img
                    src="/assets/images/home/photo2.jpg"
                    alt="Image 1"
                    className="w-full h-full object-cover"
                  />
                }
                overlay={
                  <div className="photo-card">
                    <p className="photo-card-description">
                      ...It wasn’t until 2021 that fate brought them together again,
                      this time through the world of dating apps.
                      Thuyan was initially skeptical about online dating,
                      until she spotted a familiar face she couldn’t quite place.
                      Jerry was the very first person she swiped right on...
                    </p>
                  </div>
                }
              />
            </FadeIn>
            <FadeIn manualStart={true} start={isInView} delay={1.2} className="flex-1 hover:cursor-pointer">
              <HoverFade
                className="aspect-[2/3] relative"
                front={
                  <img
                    src="/assets/images/home/photo3.jpg"
                    alt="Image 1"
                    className="w-full h-full object-cover"
                  />
                }
                overlay={
                  <div className="photo-card">
                    <p className="photo-card-description">
                      ...When Jerry saw the notification, he immediately recognized her.
                      After a few dates, things just felt right, and the rest is history.
                      Today, Jerry and Thuyan live happily in Northern Virginia with their beloved little dog, Zuko.
                    </p>
                  </div>
                }
              />
            </FadeIn>
          </div>
        </div>
      </Container>
    </Section >
  )
}